import { getDefaultMenuItems } from '../constants/routes.constants'
import { DefaultMenuConfig } from '../types/routing.types'

export const getFilteredMenuItems = (
  userPolicies: string[],
): DefaultMenuConfig[] => {
  const menuItems = getDefaultMenuItems()

  return menuItems.filter((item) => {
    if (!item.policy) return true
    return userPolicies.includes(item.policy)
  })
}

export const shouldShowMenuItem = (
  menuItem: DefaultMenuConfig,
  userPolicies: string[],
): boolean => {
  if (!menuItem.policy) return true
  return userPolicies.includes(menuItem.policy)
}
